<template>
    <div>
        <div class="listingPageTitle">
            <h1>Shared Detail Maintenance</h1>
            <ItemModal ref="modal" :refreshItemsFunction="onModalReturn" newTagType="AccordionDetail"></ItemModal>
            <GeneralModal v-show="isModalVisible == true" @close="closeModal">
                <template v-slot:body>
                    <FKLookupListing  recordType="Accordions" editPage="AccordionEdit" :onLoadData="getAccordions" :key="FKComponentKey"></FKLookupListing>
                </template>
            </GeneralModal>
        
        </div>
        <div class="searchContainer">
            <div class="formRow"><span class="inputTitle">Search Description: </span><input type="text" v-model="searchText" /></div>
            <div class="formRow"><span class="inputTitle">Search Tag: </span>
                <VueMultiselect v-model="selectedTags" :multiple="true" :close-on-select="false" :options="tags" :taggable="true" style="width: 400px" >
                    <template #noResult>No elements found.</template>
                </VueMultiselect>
             </div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc' }" />
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ItemModal from '@/components/sharedAccordionDetail/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';
import VueMultiselect from 'vue-multiselect';
import GeneralModal from '@/components/shared/GeneralModal.vue';
import FKLookupListing from '@/components/shared/FKLookupListing.vue';


export default {
    name: 'SharedDetailListing',
    components: {ItemModal, ListingTable, VueMultiselect, GeneralModal, FKLookupListing },
    data: function() {
        return {
            records: null,
            searchText: "",
            selectedTags: null,
            tags: [],
            tagTypes: null,
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Description",
                    width: "60%",
                    fieldName: "description"
                },
                {
                    headerDisplayName: "Tags",
                    width: "20%",
                    fieldName: "tagString"
                },
                {
                    width: "10%",
                    columnType: "buttons",
                    showDeleteFieldName: "showDelete",
                    showUndeleteFieldName: null,
                    showListingFieldName: "showListing",
                    showEditFieldName: "showEdit"
                }
            ],
            isModalVisible: {
                type: Boolean,
                default: false
            },
            actionMappings: {
                onLoadData: this.loadRecords, 
                onShowListing: this.showListing, 
                onDelete: this.deleteRecord, 
                onEdit: this.editRecord
            },
            FKComponentKey: 0,
            activeSharedDetailID: 0,
            usedAccordions: []
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: ["description"],
                    value: this.searchText
                });

            if(this.selectedTags != null) {
                criteria.push( {
                    dataType: "StringArray",
                    fieldName: "tags",
                    value: this.selectedTags
                });
            }
          
     
            return criteria;
        }
    },
    methods: {
        showListing(row) {
            if(row.usageCounter > 0) {
                this.activeSharedDetailID = row.id;
                this.FKComponentKey++;
                this.isModalVisible = true;
            }
        },
        getAccordions:  async function() {
            if(this.activeSharedDetailID > 0) {
                return await data.getAllAccordions('', '', 0, this.activeSharedDetailID);
            }
            else 
                return [];
        },
        closeModal: function() {
            this.isModalVisible = false;
        },
        loadRecords: async function() {
            var tags = await data.getTags("", "AccordionDetail", true);
            this.tags = tags.map( obj => { return obj.name});

            const dat = await data.getSharedDetails("");
            for(var i = 0; i < dat.length; i++) {
                dat[i].tagString = dat[i].tags.join("<br />");
                dat[i].showEdit = true;
                dat[i].showDelete = dat[i].usageCounter === 0;
                dat[i].showListing = dat[i].usageCounter > 0;
            }

            return dat;
        },
        onModalReturn() {
            this.componentKey++;
        },
        editRecord: async function(values) {
            var sharedDetail = await data.getSharedDetail(values.id);  
            this.$refs.modal.editRecord(sharedDetail);  
        },
        deleteRecord: async function(values) {
            if(confirm('Are you sure you want to delete this Shared Acccordion Detail?')) {
                var status = await data.deleteSharedDetail(values.id);
                if(status.success) 
                {
                    this.$toast.success('Record Deleted!');  
                    return true;
                }
                else 
                {
                    this.$toast.error("Could not delete Shared Detail");
                    return false;
                }     
            }             
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
